import service from "./request.js";

// 获取新闻列表
export const getNewsList = (params) => service({
    url: `/api/Portal/New/GetListByPage`,
    method: "POST",
    data: params,
});

// 浏览量添加
export const addPV = (params) => service({
    url: `/api/Portal/New/PV`,
    method: "POST",
    data: params,
});

// 获取上下篇数据
export const perNextDetail = (params) => service({
    url: `/api/Portal/New/GetInfoPN`,
    method: "POST",
    data: params,
});


// WEBPACK FOOTER //
// ./src/utils/api.js